/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_UkInputs */

const en_val_uk = /** @type {(inputs: Val_UkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UK`)
};

const es_val_uk = /** @type {(inputs: Val_UkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UK`)
};

const fr_val_uk = /** @type {(inputs: Val_UkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UK`)
};

const de_val_uk = /** @type {(inputs: Val_UkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UK`)
};

const ja_val_uk = /** @type {(inputs: Val_UkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UK`)
};

const zh_val_uk = /** @type {(inputs: Val_UkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`英码 (UK)`)
};

const ar_val_uk = /** @type {(inputs: Val_UkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بريطاني (UK)`)
};

const id_val_uk = /** @type {(inputs: Val_UkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UK`)
};

const it_val_uk = /** @type {(inputs: Val_UkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UK`)
};

const ru_val_uk = /** @type {(inputs: Val_UkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UK`)
};

const pt_val_uk = /** @type {(inputs: Val_UkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UK`)
};

const ko_val_uk = /** @type {(inputs: Val_UkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UK (영국 사이즈)`)
};

/**
* | output |
* | --- |
* | "UK" |
*
* @param {Val_UkInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_uk = /** @type {((inputs?: Val_UkInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_UkInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_uk(inputs)
	if (locale === "es") return es_val_uk(inputs)
	if (locale === "fr") return fr_val_uk(inputs)
	if (locale === "de") return de_val_uk(inputs)
	if (locale === "ja") return ja_val_uk(inputs)
	if (locale === "zh") return zh_val_uk(inputs)
	if (locale === "ar") return ar_val_uk(inputs)
	if (locale === "id") return id_val_uk(inputs)
	if (locale === "it") return it_val_uk(inputs)
	if (locale === "ru") return ru_val_uk(inputs)
	if (locale === "pt") return pt_val_uk(inputs)
	return ko_val_uk(inputs)
});